import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/NoResults.svg'


const _hoisted_1 = { class: "wrapper-advances" }
const _hoisted_2 = { class: "above-table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "empty"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConfirmCancellation = _resolveComponent("ModalConfirmCancellation")!
  const _component_ModalReasonCancellation = _resolveComponent("ModalReasonCancellation")!
  const _component_ModalReceipt = _resolveComponent("ModalReceipt")!
  const _component_ModalImages = _resolveComponent("ModalImages")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Searcher = _resolveComponent("Searcher")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_TableButton = _resolveComponent("TableButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalConfirmCancellation, {
      onCloseConfirmCancellation: _ctx.closeConfirmCancellationModal,
      onOpenReasonCancellationModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.manageReasonCancellationModal(true))),
      message: _ctx.message
    }, null, 8, ["onCloseConfirmCancellation", "message"]), [
      [_vShow, _ctx.modalConfirmCancellation]
    ]),
    _withDirectives(_createVNode(_component_ModalReasonCancellation, {
      onCloseReasonCancellation: _ctx.closeReasonCancellationModal,
      onNullify: _ctx.nullifyAdvanceTransaction
    }, null, 8, ["onCloseReasonCancellation", "onNullify"]), [
      [_vShow, _ctx.modalReasonCancellation]
    ]),
    _withDirectives(_createVNode(_component_ModalReceipt, {
      onCloseReceipt: _ctx.closeReceiptModal,
      receiptUrl: _ctx.selectedReceiptUrl
    }, null, 8, ["onCloseReceipt", "receiptUrl"]), [
      [_vShow, _ctx.modalReceipt]
    ]),
    _withDirectives(_createVNode(_component_ModalImages, {
      onCloseImages: _ctx.closeImagesModal,
      listImages: _ctx.selectedImages
    }, null, 8, ["onCloseImages", "listImages"]), [
      [_vShow, _ctx.modalImages]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Anticipos", -1)),
        _createVNode(_component_DatePicker, {
          label: 'Fecha',
          onChange: _ctx.handleDateChange
        }, null, 8, ["onChange"]),
        _createVNode(_component_Searcher, {
          placeholder: "Busca por no. provisional...",
          isDisabled: _ctx.advances.length === 0,
          search: _ctx.query,
          "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event))
        }, null, 8, ["isDisabled", "search"]),
        (_ctx.isDateSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("a", {
                href: _ctx.route,
                class: "wrapper-button"
              }, [
                _createVNode(_component_StandardButton, {
                  buttonLabel: 'Exportar archivo',
                  isDisabled: _ctx.advances.length === 0
                }, null, 8, ["isDisabled"])
              ], 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.advances.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Sin resultados",
              class: "icon"
            }, null, -1),
            _createElementVNode("p", { class: "text-empty" }, "Selecciona una fecha para ver los anticipos", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "No. provisional"),
                _createElementVNode("th", null, "No. factura"),
                _createElementVNode("th", null, "Vendedor"),
                _createElementVNode("th", null, "Cliente"),
                _createElementVNode("th", null, "Pago"),
                _createElementVNode("th", null, "Fecha pago"),
                _createElementVNode("th", null, "Valor pago"),
                _createElementVNode("th", null, "Recibo"),
                _createElementVNode("th", null, "Imágenes"),
                _createElementVNode("th", null, "Estado"),
                _createElementVNode("th", null, "Anular")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAdvances, (advance, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(advance.receiptNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(advance.orderNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(advance.sellerName), 1),
                  _createElementVNode("td", null, _toDisplayString(advance.clientName), 1),
                  _createElementVNode("td", null, _toDisplayString(advance.methodOfPayment), 1),
                  _createElementVNode("td", null, _toDisplayString(advance.paymentDate), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(advance.value)), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_TableButton, {
                      type: "Receipt",
                      onClick: ($event: any) => (_ctx.openReceiptModal(advance))
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_TableButton, {
                      type: "Images",
                      onClick: ($event: any) => (_ctx.openImagesModal(advance))
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(advance.state), 1),
                  _createElementVNode("td", null, [
                    (advance.state !== 'ANULADO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_TableButton, {
                            type: "Cancel",
                            onClick: ($event: any) => (_ctx.manageConfirmCancellationModal(advance))
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]))
    ])
  ], 64))
}